module.exports = __webpack_public_path__ + "static/img/bs_content1.456be93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bs_content1.png
// module id = OZGo
// module chunks = 0